module.exports = __webpack_public_path__ + "img/car-compare.2075f2e.webp";